import React from 'react';
import { Button as ButtonV } from '@beisen/chaos-ui';

class Button extends React.Component {
	constructor(props) {
		super(props);
		this.touchHandler = this.touchHandler.bind(this);
	}

	touchHandler(e) {
		document.activeElement.blur();
		this.props.onTouchTap(e);
	}

	render() {
		return (
			this.props.cmp_type ?
            <ButtonV cls={this.props.cls}
                type={this.props.type}
				text={this.props.cmp_label}
				style={this.props.style}
				icon={this.props.icon}
				onTouchTap={this.props.onButtonTouchTap}
				disabled={this.props.disabled} />
			:
            <ButtonV cls={this.props.cls}
                type={this.props.type}
				text={this.props.cmp_label}
				padding={this.props.padding || '12px'}
				background={this.props.background || '#f5f6f7'}
				style={this.props.style}
				icon={this.props.icon}
				onTouchTap={this.touchHandler}
				disabled={this.props.disabled} />
			);
	}
}
export default Button;



// WEBPACK FOOTER //
// ./src/components/Field_Components/Button/Button.js